{
  "nav": {
    "dashboard": "Översikt",
    "teacherDashboard": "Mina sessioner",
    "projects": "Projekt",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Lämna Fair Quote",
    "contacts": "Kontakter",
    "entities": "Entiteter",
    "products": "Produkter",
    "colors": "Färger",
    "courses": "Kurser",
    "teachers": "Lärare",
    "students": "Studenter",
    "certifications": "Certifieringar",
    "staff": "Personal",
    "company": "Mitt företag",
    "overview": "Översikt",
    "sections": {
      "projects": "Projekt",
      "shop": "Butik & Katalog",
      "entity": "Enhetsyta",
      "learning": "Utbildning",
      "admin": "Administration"
    },
    "enrollments": "Registreringar",
    "calendar": "Kalender",
    "userManagement": "Användarhantering",
    "applicatorProfiles": "Applikatörsprofiler",
    "certificationDefinitions": "Certifieringsdefinitioner",
    "switchEntity": "Byt entitet"
  }
}
